import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
//this._pos.getAllPOS()
export class EmployeesService {
  constructor(private http: HttpClient) { }
  getAllEmployees(page:any): Observable<any> {
    return this.http.post(`${environment.Server_URL}/all/employees?page=${page}`,{});
  }
  createEmployee(formData: FormData): Observable<any> {
    return this.http.post(`${environment.Server_URL}/employees`, formData);
  }
  editEmployee(formData: FormData, id: any): Observable<any> {
    return this.http.post(`${environment.Server_URL}/employees/${id}`, formData);

  }
  deleteEmployee(id: string): Observable<any> {
    return this.http.delete(`${environment.Server_URL}/employees/${id}`);
  }
  getOneEmployees(id: string): Observable<any> {
    return this.http.get(`${environment.Server_URL}/employees/${id}`);
  }
  addBonus(id: string,formData: any): Observable<any> {
    return this.http.post(`${environment.Server_URL}/employees/${id}/bonus`,formData);
  }
  addLoan(id: string,formData: any): Observable<any> {
    return this.http.post(`${environment.Server_URL}/employees/${id}/loan`,formData);
  }
  addDeduction(id: string,formData: any): Observable<any> {
    return this.http.post(`${environment.Server_URL}/employees/${id}/deduction`,formData);
  }
getEmployeesByWarehouse(warehouseId: number, page: number = 1, perPage: number = 10): Observable<any> {
  return this.http.get(`${environment.Server_URL}/employees/warehouse/${warehouseId}`, {
    params: {
      page: page.toString(),
      per_page: perPage.toString()
    }
  });
}


}
